import axios from 'axios'
import React, { useEffect, useState } from 'react'
import { Card, Spinner, Table, Badge, Nav } from 'react-bootstrap'
import { useHistory, useLocation, Link } from 'react-router-dom'
import { VendorMyScreensEnd, VendorProfileEnd } from '../../constants/api.constants'
import Toast from '../../utils/Toast/Toast'
import './VendorDashboard.scss'

const VendorDashboard = () => {
  const history = useHistory()
  const location = useLocation()
  const [screens, setScreens] = useState([])
  const [vendorInfo, setVendorInfo] = useState({})
  const [spinner, setSpinner] = useState(true)

  useEffect(() => {
    const token = localStorage.getItem('vendor_token')
    if (!token) {
      history.push('/login')
      return
    }
    loadVendorProfile()
    loadMyScreens()
  }, [])

  const loadVendorProfile = async () => {
    try {
      const response = await axios.get(VendorProfileEnd, {
        headers: {
          menuboard: localStorage.getItem('vendor_token'),
        },
      })
      if (response.status === 200) {
        setVendorInfo(response.data.data?.data || {})
      }
    } catch (error) {
      if (error.response?.status === 401 || error.response?.status === 403) {
        Toast('err', 'Session expired. Please login again.')
        handleLogout()
      }
    }
  }

  const loadMyScreens = async () => {
    setSpinner(true)
    try {
      const response = await axios.get(VendorMyScreensEnd, {
        headers: {
          menuboard: localStorage.getItem('vendor_token'),
        },
      })
      if (response.status === 200) {
        setScreens(response.data.data || [])
        setSpinner(false)
      }
    } catch (error) {
      setSpinner(false)
      if (error.response?.status === 401 || error.response?.status === 403) {
        Toast('err', error.response?.data?.msg || 'Session expired. Please login again.')
        handleLogout()
      } else {
        Toast('err', error.response?.data?.msg || 'Failed to load screens')
      }
    }
  }

  const handleLogout = () => {
    localStorage.removeItem('vendor_token')
    localStorage.removeItem('vendor_info')
    localStorage.removeItem('user_role')
    localStorage.setItem('default_path', '/')
    history.push('/login')
  }

  const formatDate = (dateString) => {
    if (!dateString) return 'No Expiry (Perpetual)'
    const date = new Date(dateString)
    return date.toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
    })
  }

  return (
    <div className='vendor-dashboard py-4'>
      {/* Vendor Sidebar Navigation */}
      <Card className='mb-4'>
        <Card.Body className='py-2'>
          <Nav variant='pills' className='vendor-nav'>
            <Nav.Item>
              <Nav.Link
                as={Link}
                to='/vendor-dashboard'
                active={location.pathname === '/vendor-dashboard'}
              >
                Dashboard
              </Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link
                as={Link}
                to='/vendor-ad-management'
                active={location.pathname === '/vendor-ad-management'}
              >
                Ad Management
              </Nav.Link>
            </Nav.Item>
            <Nav.Item className='ms-auto'>
              <Nav.Link onClick={handleLogout} className='text-danger'>
                Logout
              </Nav.Link>
            </Nav.Item>
          </Nav>
        </Card.Body>
      </Card>

      <div className='d-flex justify-content-between align-items-center mb-4'>
        <div>
          <h3 className='fw-bold mb-1'>Welcome, {vendorInfo.name || 'Vendor'}</h3>
          <p className='text-muted mb-0'>
            Access expires: {formatDate(vendorInfo.expiry_date)}
          </p>
        </div>
      </div>

      <Card className='mb-4'>
        <Card.Header>
          <h5 className='mb-0'>My Assigned Screens</h5>
        </Card.Header>
        <Card.Body>
          {spinner ? (
            <div className='text-center py-5'>
              <Spinner animation='border' style={{ color: '#558f55' }} />
            </div>
          ) : screens.length > 0 ? (
            <Table striped bordered hover responsive>
              <thead>
                <tr>
                  <th>#</th>
                  <th>Screen Name</th>
                  <th>Store</th>
                  <th>Screen ID</th>
                  <th>Type</th>
                  <th>Orientation</th>
                </tr>
              </thead>
              <tbody>
                {screens.map((screen, idx) => (
                  <tr key={screen._id}>
                    <td>{idx + 1}</td>
                    <td>{screen.screen_name}</td>
                    <td>{screen.store_id?.name || 'N/A'}</td>
                    <td>
                      <code>{screen.unique_id}</code>
                    </td>
                    <td>
                      <Badge bg='info'>{screen.screen_type}</Badge>
                    </td>
                    <td>{screen.orientation || 'landscape'}</td>
                  </tr>
                ))}
              </tbody>
            </Table>
          ) : (
            <div className='text-center py-5'>
              <h5 className='text-muted'>No screens assigned yet</h5>
              <p className='text-muted'>
                Contact your administrator to get screens assigned to your account.
              </p>
            </div>
          )}
        </Card.Body>
      </Card>

      <Card>
        <Card.Header>
          <h5 className='mb-0'>Account Information</h5>
        </Card.Header>
        <Card.Body>
          <div className='row'>
            <div className='col-md-6'>
              <p><strong>Name:</strong> {vendorInfo.name}</p>
              <p><strong>Email:</strong> {vendorInfo.email}</p>
            </div>
            <div className='col-md-6'>
              <p><strong>Status:</strong> <Badge bg={vendorInfo.is_active ? 'success' : 'danger'}>{vendorInfo.is_active ? 'Active' : 'Inactive'}</Badge></p>
              <p><strong>Access Expiry:</strong> {formatDate(vendorInfo.expiry_date)}</p>
            </div>
          </div>
        </Card.Body>
      </Card>
    </div>
  )
}

export default VendorDashboard
